document.addEventListener("DOMContentLoaded", () => {
  // Open the link in a new browser tab
  ['https://view.flipdocs.com/?ID=10023649_858855', 'https://policies.google.com/privacy?hl=en', 'https://aloeup.markettime.com/']
    .forEach(url => {
      const link = document.querySelector(`a[href="${url}"]`);
      if (link) link.setAttribute('target', '_blank');
    });


  // product page custom accordian
  let product_acc = document.querySelector('.product_custom_accordian');
  let coll_acc = document.querySelector('.template_grizzly .collection-description');
  if (product_acc || coll_acc) {
    var acc = document.getElementsByClassName("Collapsible__Button");
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.display === "block") {
          panel.style.display = "none";
        } else {
          panel.style.display = "block";
        }
      });
    }
  }

  // Home Page Popular collection Section

  let currentHoveredElement = document.querySelector('.cursor_pointer.image-matched');

  function changeImage(custom_element) {
    if (currentHoveredElement && currentHoveredElement !== custom_element) {
      currentHoveredElement.classList.remove('image-matched');
    }

    custom_element.classList.add('image-matched');
    currentHoveredElement = custom_element;

    const imageUrl = custom_element.getAttribute('data_image');
    const imageElement = document.querySelector('.productImage');
    if (imageElement && imageUrl) {
      imageElement.src = imageUrl;
    }

    const linkElement = document.getElementById('productLink');
    const linkUrl = custom_element.getAttribute('data_link');
    if (linkElement && linkUrl) {
      linkElement.href = linkUrl;
    }
  }

  document.querySelectorAll('.cursor_pointer').forEach(element => {
    element.addEventListener('mouseover', function () {
      changeImage(this);
    });
  });
 

  //collection page product infinite scroll
  const productGrid = document.querySelector('[id^="product-list-"]');
  if (productGrid) {
    const scrollEnable = productGrid.getAttribute('data-scroll');

    if (scrollEnable === 'enabled') {

      // Scroll event for auto-clicking pagination link
      window.addEventListener('scroll', () => {
        const paginationLink = document.querySelector('#Huratips-Pagination a');

        if (paginationLink && !paginationLink.classList.contains('loading')) {
          paginationLink.classList.add('loading');
          paginationLink.click();
        }
      });

      // Click event for AJAX-based pagination
      document.addEventListener('click', function (e) {
        const target = e.target;

        if (target.matches('#Huratips-Pagination a')) {
          e.preventDefault();

          const scrollURL = target.getAttribute('href');
          fetch(scrollURL)
            .then(response => response.text())
            .then(data => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(data, 'text/html');

              const newPagination = doc.querySelector('#Huratips-Pagination');
              const productItems = doc.querySelector('[id^="product-list-"]');

              const paginationContainer = document.querySelector('#Huratips-Pagination');
              const productGrid = document.querySelector('[id^="product-list-"]');

              if (newPagination) {
                paginationContainer.innerHTML = newPagination.innerHTML;
              } else {
                paginationContainer.remove();
                document.querySelector('.order_2')?.classList.add('active');
              }

              if (productItems) {
                productGrid.insertAdjacentHTML('beforeend', productItems.innerHTML);
              }
            });
        }
      });
    }
  }


  
});